import { render } from "./IconTool.vue?vue&type=template&id=7c4b6c84&scoped=true"
import script from "./IconTool.vue?vue&type=script&lang=js"
export * from "./IconTool.vue?vue&type=script&lang=js"

import "./IconTool.vue?vue&type=style&index=0&id=7c4b6c84&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4b6c84"]])

export default __exports__